export default __webpack_public_path__ + "static/media/caps-leave-icon.3e7c83a5.png";